import React, { useState } from "react";
import { Card, CardContent, Typography, TextField, Button, Box } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import SMSPreview from "./SMSPreview";

const TextMessageTemplatePreview = () => {
  const [templateName, setTemplateName] = useState("");
  const [templateFormat, setTemplateFormat] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("token");

  // Word count calculation
  const wordCount = templateFormat.trim() === "" ? 0 : templateFormat.trim().split(/\s+/).length;
  
  // Message count calculation (160 characters = 1 message)
  const messageCount = templateFormat.length === 0 ? 0 : Math.ceil(templateFormat.length / 160);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!templateName || !templateFormat) {
      toast.error("Template Name and SMS Content are required.");
      return;
    }
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}admin/text-template`,
        {
          templateName,
          templateType: "text",
          templateFormat,
        },
        {
          headers: {
            "x-access-token": token,
            version: "1.0.0",
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        toast.success("Text template created successfully!");
        setTemplateName("");
        setTemplateFormat("");
      } else {
        toast.error(response.data.message || "Failed to create template");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to create template");
    }
    setIsLoading(false);
  };

  return (
    <Box sx={{ display: "flex", gap: "20px", width: "100%", flexWrap: "wrap", overflowX: "auto", minWidth: "320px" }}>
      {/* Left Side - Form Controls */}
      <Card sx={{ flex: { xs: "100%", md: 1 }, boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", minWidth: { xs: "100%", md: "auto" } }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Text Template Configuration
          </Typography>
          <form onSubmit={handleSubmit}>
            <Box sx={{ display: "flex", gap: 2, mb: 3, alignItems: "center", flexWrap: "wrap" }}>
              <TextField
                fullWidth
                label="Template Name"
                value={templateName}
                onChange={(e) => setTemplateName(e.target.value)}
                inputProps={{ maxLength: 100 }}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2, mb: 1, alignItems: "center", flexWrap: "wrap" }}>
              <TextField
                fullWidth
                label="SMS Content"
                value={templateFormat}
                onChange={(e) => setTemplateFormat(e.target.value)}
                multiline
                minRows={4}
                // No maxLength restriction
                helperText={`${
                  templateFormat.length
                } characters | ${
                  templateFormat.trim().split(/\s+/).filter(Boolean).length
                } words | ${messageCount} message(s)`}
              />
            </Box>
            {/* <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
              Word count: {wordCount}
            </Typography> */}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              sx={{ mt: 1 }}
              disabled={isLoading}
            >
              {isLoading ? "Submitting..." : "Submit"}
            </Button>
          </form>
        </CardContent>
      </Card>
      {/* Right Side - Preview */}
      <Card sx={{ flex: 1, height: "100%", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Preview
          </Typography>
          <SMSPreview messageText={templateFormat} showInput={false} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default TextMessageTemplatePreview; 